import { render } from "./dialogRegresarOficio.vue?vue&type=template&id=7f7b5656&scoped=true"
import script from "./dialogRegresarOficio.vue?vue&type=script&lang=js"
export * from "./dialogRegresarOficio.vue?vue&type=script&lang=js"

import "./dialogRegresarOficio.vue?vue&type=style&index=0&id=7f7b5656&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7b5656"]])

export default __exports__